// import { APIService } from "@/service/api.js";
// import urlConstant from "@/constants/uri.constants.js";

const state = {
  testData: {}
}

const mutations = {
//   fetchTopicList(state, payload) {
//     switch (payload.type) {
//       case "FETCHING_TOPIC_LIST":
//         state.topicData = {
//           isFechingTopicList: true,
//           errorFechingTopicList: false,
//           responseData: {}
//         };
//         break;
//       case "FETCHED_TOPIC_LIST":
//         state.topicData = {
//           isFechingTopicList: false,
//           errorFechingTopicList: false,
//           responseData: payload.data
//         };
//         break;
//       case "ERROR_FETCHING_TOPIC_LIST":
//         state.topicData = {
//           isFechingTopicList: false,
//           errorFechingTopicList: true,
//           responseData: {}
//         };
//         break;
//     }
//   },
}

const actions = {
//   createTopic({ commit }, _createTopic) {
//     commit("createTopic", { type: "CREATING_TOPIC" });
//     APIService.post(urlConstant.baseUrl+urlConstant.getTopic, _createTopic)
//       .then(res => {
//         if (res.data) {
//           // console.log(res.data);
//           commit("createTopic", { type: "CREATED_TOPIC", data: res.data });
//         }
//       })
//       .catch(err => {
//         console.log("createTopic", err);
//       });
//   }

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
